<template>
  <div class="info wrap"  v-if="infoShow === true">
    <div class="info-cover">
    <div class="info-box">
      <p class="title">{{ title }}</p>
      <div v-html="message"></div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "info",
  components: {},
  data() {
    return {
      title: "",
      message: "",
      infoShow: true,
    };
  },
  computed: {
    rootUrl() {
      return this.$store.getters.rootUrl;
    },
  },
  created() {
    // var def = this.abc(1);
    // alert(def);
    this.$axios
      .get(`${this.rootUrl}/api/get-post.php`)
      .then((response) => {
        console.log(response);
        // alert(response.data.status);
        if (response.data.status === 200) {
          // alert(response.data.message);
          // console.log('ok')
          this.title = response.data.title;
          this.message = response.data.message;
          if (response.data.visible === "1") {
            this.infoShow = true;
          } else if (response.data.visible === "0") {
            this.infoShow = false;
          } else {
            alert("エラーが発生しました。");
          }
          // this.pageType = 1;
          return;
        } else if (
          response.data.status === 401 ||
          response.data.status === 400
        ) {
          alert(response.data.message);
          return;
        } else {
          alert("エラーが発生しました。");
          return;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.info {
  margin-top: 30px;
  margin-bottom: 30px;
  }
.info-cover {
  background-color: black;
}
.info-box {
  // border-top: solid 2px var(--white);
  // border-bottom: solid 2px var(--white);
  text-align: center;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
    @media screen and (max-width: 767px){
      text-align: left;
    }


  .title {
    padding: 10px 0 20px 0;
    font-size: 25px;
     @media screen and (max-width: 767px){
       font-size: 23px;
     }
  }
}
</style>
